import { render, staticRenderFns } from "./ReportsCenterDetail.vue?vue&type=template&id=e6c326ce"
import script from "./ReportsCenterDetail.vue?vue&type=script&lang=js"
export * from "./ReportsCenterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports